import { SearchState, SearchAction, SearchActionTypes } from './types';



export const initialState: SearchState = {
    data: {},
    showResults: false,
    promptHistory: []
};

export const searchReducer = (state: SearchState, action: SearchAction): SearchState => {
    switch (action.type) {        
        case SearchActionTypes.SET_DATA:
            return { ...state, data: action.payload };

        case SearchActionTypes.TOGGLE_RESULTS:
            return { ...state, showResults: action.payload };

        case SearchActionTypes.ADD_PROMPT_HISTORY:
            return { ...state, promptHistory: action.payload };
        case SearchActionTypes.RESET:
            return initialState;
        default:
            return state;
    }
};
